import { nullRolePermissions } from '@projectMembers/models/projectRolePermissions';
import useCurrentUserProjectRole from './useCurrentUserProjectRole';

const useCurrentUserProjectPermissions = ( projectID?: number | null ) => {
	const projectRole = useCurrentUserProjectRole( projectID );

	return projectRole?.permissions ?? nullRolePermissions;
};

export default useCurrentUserProjectPermissions;
